module.exports = __webpack_public_path__ + "static/media/bg_light.4b5684eb.jpg";